<div class="row mt-4 me-5 pt-1 pb-5 align-items-center rounded-3 border shadow-lg content-container">
    <div class="col-12 ms-4 mb-5">
        <h2>Nombre total de personnes au Vin d'Honneur: <span class="value-total">{{numberOfAcceptedPersons()}}</span></h2>
        <h2>Nombre de personnes au Vin d'Honneur uniquement: <span
                class="value-vh">{{numberOfTotalAcceptedVHPersons()}}</span></h2>
        <h2>Nombre de personnes au repas: <span class="value-repas">{{numberOfTotalAcceptedMealPersons()}}</span> dont <span class="value-repas">{{numberOfAcceptedChildrens()}}</span> enfant(s)</h2>
        <h2>Nombre de personnes au brunch du dimanche: <span
                class="value-brunch">{{numberOfTotalAcceptedBrunchPersons()}}</span></h2>
        <h2>Nombre total de personnes invitées: <span class="value-invite">{{numberOfAcceptedPersons() +
                numberOfNotSurePersons() + numberOfRefusedPersons() + numberOfWaitingPersons()}}</span></h2>

    </div>


    <div class="col-12 col-lg-4">
        <canvas baseChart [data]="responseDoughnutData()" [options]="responseDoughnutOptions()" [type]="'doughnut'">
        </canvas>
    </div>

    <div class="col-12 col-lg-4">
        <canvas baseChart [data]="invitationTypeAcceptedDoughnutData()"
            [options]="invitationTypeAcceptedDoughnutOptions()" [type]="'doughnut'"> </canvas>
    </div>

    <div class="col-12 col-lg-4">
        <canvas baseChart [data]="invitationTypeInvitedDoughnutData()"
            [options]="invitationTypeInvitedDoughnutOptions()" [type]="'doughnut'"> </canvas>
    </div>

</div>